// extracted by mini-css-extract-plugin
export default {"row":"LoaderRow-module__row__EwELc","cell":"LoaderRow-module__cell__e11r3","content":"LoaderRow-module__content__MamF4","text":"LoaderRow-module__text__6eQl4"};